import React, { useRef } from "react";
import { AnimBtn } from "../AnimBtn";
import circles from "../../../assets/img/landings/circles.svg";
import useAnimation from "./useAnimation";
import "./index.css";
import RequestDemo from "../../Button/RequestDemo";
import btnClasses from "../../commons/Button.module.scss";

const Challenge = ({
  heroTitle,
  heroSubTitle,
  challengeTitle,
  sctRef,
  children,
  animation,
  preAnimate,
  isStarted,
  setIsStarted,
  isFinished,
  setIsFinished,
  afterAnimate,
}) => {
  const animRef = useRef(null);

  useAnimation(
    preAnimate,
    animation,
    sctRef,
    animRef,
    isStarted,
    isFinished,
    setIsFinished,
    setIsStarted,
    afterAnimate
  );

  return (
    <section className="challenge" ref={animRef}>
      <div className="container">
        <div className="challenge__body">
          <div className="challenge__image">{children[0]}</div>
          {!isFinished && (
            <article className="hero__content">
              <div className="hero__bgr">
                <img src={circles} alt="circles" />
              </div>
              <h1 className="hero__title">{heroTitle}</h1>
              <h2 className="hero__subtitle">{heroSubTitle}</h2>
              {children[1]}
              <RequestDemo className={btnClasses.button} />
            </article>
          )}
          <article className="challenge__content">
            <div className="challenge__bgr">
              <img width="360" height="360" src={circles} alt="circles" />
            </div>
            <h2 className="challenge__title">{challengeTitle}</h2>
            {children[2]}
          </article>
        </div>
      </div>
      <AnimBtn
        setIsFinished={setIsFinished}
        setIsStarted={setIsStarted}
        isStarted={isStarted}
        isFinished={isFinished}
      />
    </section>
  );
};

export default Challenge;
